import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import api from '../config';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import Table from "../Common/table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import _ from "lodash";
import 'react-toastify/dist/ReactToastify.css';
import XLSX from 'xlsx';
import valid from '../utill/validation';
import joi from 'joi';
import { Modal } from 'react-bootstrap';
import { DropDownInputCompForObject, TextInputComp, TextInputFieldComp } from '../utill/testreusablecomponent';
import Loading from '../utill/LoadingComponent';
import dateTime from '../utill/dateTime';

const MasterTemplate = ({ FieldName, ApiName, MasterHeading, renderComp, modalSize, schema, RightName, getRightsForAccess,Heading }) => {
  const [dataForApi, setdataForApi] = useState({});
  const [oldObj, setOldObj] = useState({});
  const [errors, setErrors] = useState({});
  const [querySuccess, setQuerySuccess] = useState(false);
  const [InputData, setInputData] = useState([]);
  const [Loadtable, setLoadtable] = useState(false);
  const [ActionStatus, setActionStatus] = useState('Add');
  const [excelData, setExcelData] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [rowNumber, setRowNumber] = useState(0);
  const [errorFlag, setErrorFlag] = useState(false);
  const [datafromoutercomponent, setdatafromoutercomponent] = useState([]);


  // function createSchema(fields) {
  //   const schema = {};
  //   fields.forEach(field => {
  //     schema[field] = joi.string().required().label(field);
  //   });
  //   return schema;
  // }
  // const schema = {
  //   RequestType:joi.string().required().label('RequestType')
  // };
  //   const fields = ['RequestType'];
  // const schema = createSchema(fields);

  console.log(MasterHeading, "custom component data", FieldName)
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    const errorMessage = valid.validateProperty(e.currentTarget, schema);
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: errorMessage || null
    }));
    // Check if the field name is 'No_Of_Shots' or 'No_Of_Days'

    // Update other fields normally
    setdataForApi(prevEquipmentType => ({
      ...prevEquipmentType,
      [name]: value
    }));

  };
  useEffect(() => {
    Heading(MasterHeading)
    console.log(MasterHeading,"ivivbdfvbdfvh")

  }, [MasterHeading])
  
  useEffect(() => {
    setQuerySuccess(true);
    axios
      .get(api.api + `${ApiName}`)
      .then((result) => {
        if (result.status == 200) {
          console.log(result.data, "fdvduhhivfb")
          setInputData(result.data);
          setQuerySuccess(false);

        } else {
          setQuerySuccess(false);

        }
      })
      .catch((err) => {
        setQuerySuccess(false);

        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: 'red',
            color: 'white',
          },
        });

        swal(`${err}`);
      });
    setLoadtable(false);
  }, [Loadtable, FieldName])
  const [sortColumn, setSortColumn] = useState({ path: `createdAt`, order: 'asc' });

  const handleSort = sortColumn => {
    if (InputData.length > 0) {
      const sorted = _.orderBy(InputData, [sortColumn.path], [sortColumn.order]);
      setSortColumn(sortColumn);
      setInputData(sorted);
    }
  }




  ////////////////////////////////////////// Excel Import /////////////////////////////////
  const handleUploadGuagesDoc = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'EquipmentList');
    let self = this;

    document.body.appendChild(link);
    link.click();

    link.onchange = async function (e) {
      e.preventDefault();
      let fr = new FileReader();
      fr.readAsBinaryString(e.currentTarget.files[0]);
      fr.onloadend = async function (e) {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let dataArray = [];
        let keyArr = data[0];
        let arr = data.slice(1, data.length);
        arr.forEach((oneArr) => {
          let obj = {};
          oneArr.forEach((value, i) => {

            obj[[keyArr[i]]] = value.toString();

          });
          dataArray.push(obj);
        });
        setExcelData(dataArray);
        await sendDataToServer(dataArray, dataArray, 0);
      };
    };
    document.body.removeChild(link);
  };
  const sendDataToServer = async (DataArray, originalDataArray, idx) => {
    setQuerySuccess(true);
    for (let index = idx; index < DataArray.length; index += 1) {
      try {
        let error = valid.validate(DataArray[index], schema);
        // let error = null

        if (error !== null) {
          let row = index + 1;
          setErrors(error);
          setQuerySuccess(false);
          setErrorModal(true);
          setRowNumber(row);
          break;
        } else {
          let res = await axios.post(api.api + ApiName, { row: index + 1, data: DataArray[index] });
          const result = await axios.get(api.api1 + ApiName);
          setInputData(result.data);
          if (result.status == 200) {
            toast.success('🦄  Raw Material Saved - '
              //  DataArray[index].EquipmentID
              , {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
          }
        }
      } catch (err) {
        if (err.response.data.code === 11000) {
          AbortAndResumeProcess(DataArray, originalDataArray, index);
        } else {
          //   let message = JSON.parse(err.response.data.message);
          // console.log(err,"vsivbifv")
          //   let message = JSON.parse(err);
          toast.success(`${err}`, {
            position: 'bottom-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: {
              background: 'red', // Set your desired background color
              color: 'white',     // Set your desired text color
            },
          });
          setQuerySuccess(false);
          return
          //   setObjKey(message.key);
          //   setErrorMessage(message.message);
          //   setErrorFlag(true);
          //   if (message.key === 'DeviceID') {
          //     swal(`${message.message}  , \n  Please contact leafnet admin customer support !`, { dangerMode: true });
          //   } else {
          //     // insertIfNotExistDataTypeAndResumeProcess(message.message, message.key.toLowerCase(), message.key, DataArray[index][message.key], originalDataArray, index);
          //   }
        }
        break;
      }
    }
    setQuerySuccess(false);
  };
  const AbortAndResumeProcess = (dataArray, originalArr, index) => {
    let row = index + 1;
    swal({
      title: "Are you sure?",
      text: ' This Raw Material already exist skip this!  ',
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        index = index + 1;
        sendDataToServer(dataArray, originalArr, index)
      } else {
        // this.setState({querySuccess:false,arrayProcessIndex:index})
        swal('Process  Abort', { dangerMode: true });

        // swal("Your imaginary file is safe!");
      }
    });
  }


  const columns = [


    { path: FieldName, label: `${MasterHeading}` },
    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },

    {
      path: "edit",
      content: (obj) => (
        <button
          disabled={!getRightsForAccess("StaticDataRights", RightName, "update")}
          //  onClick={() => HandelModelOpen(obj)}
          type="button" className="btn " data-bs-toggle="modal" data-bs-target="#staticBackdrop" variant="primary" onClick={() => { setdataForApi(obj); setActionStatus('Update') }}>
          <FontAwesomeIcon icon={faEdit} color='blue' />
        </button>

      ),
    },
    {
      path: "delete",
      content: (obj) => (
        <button
          disabled={!getRightsForAccess("StaticDataRights", RightName, "update")}
          //  onClick={() => HandelModelOpen(obj)}
          type="button" className='btn ' onClick={() => { handelDataDelete(obj) }}>
          <FontAwesomeIcon icon={faTrash} color='red' />
        </button>

      ),
    },
  ]
  console.log(dataForApi, "data entered in the mould ")
  const handleSubmit = (data) => {
    console.log(data, "ergjhfks")

    if (!data[FieldName] || data[FieldName].length <= 0) {
      toast.error('Please enter data to submit', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: {
          backgroundColor: 'grey',
          color: 'white',
        },
      });
      return;
    }
    if (ActionStatus === 'Add') {
      setQuerySuccess(true);

      axios
        .post(api.api + `${ApiName}`, data)
        .then((result) => {
          if (result.status == 200) {
            setLoadtable(true);
            setQuerySuccess(false);

            toast.success('Created Successfully', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'green',
                color: 'white',
              },
            });
            setdataForApi({})
          } else {
            setQuerySuccess(false);

            toast.success("Unable to submit data", {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          }
        })
        .catch((err) => {
          setQuerySuccess(false);

          if (err.response.data.message === ' already Have') {
            toast.success('This RequestType is already present ', {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          } else {
            setQuerySuccess(false);

            toast.success(`${err?.response?.data?.message || 'Server Error'}`, {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          }
        });

    }
    // else condition when action status is update ********( ActionStatus ==='Update')
    else {
      setQuerySuccess(true);

      axios
        .patch(api.api + `${ApiName}/${data._id}`, data)
        .then((result) => {
          if (result.status == 200) {
            setLoadtable(true);
            setQuerySuccess(false);

            toast.success(' Successfully updated', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'green',
                color: 'white',
              },
            });
            setdataForApi({})
          } else {
            setQuerySuccess(false);

            toast.success("Unable to submit data", {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          }
        })
        .catch((err) => {
          setQuerySuccess(false);

          if (err.response.data.message === ' already Have') {
            toast.success(`This ${FieldName} is already present `, {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          } else {
            setQuerySuccess(false);

            toast.success(`${err?.response?.data?.message || 'Server Error'}`, {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          }
        });
    }
    setQuerySuccess(true);

    axios
      .get(api.api + `${ApiName}`)
      .then((result) => {
        if (result.status == 200) {
          setQuerySuccess(false);

          console.log(result.data, "fdvduhhivfb")
          setInputData(result.data);
        }
      })
      .catch((err) => {
        setQuerySuccess(false);

        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: 'red',
            color: 'white',
          },
        });

        swal(`${err}`);
      });
  };
  const handelDataDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        //   this.setState({ querySuccess: true });
        setQuerySuccess(true);

        axios
          .delete(api.api + `${ApiName}/${data._id}`, data)
          .then((result) => {
            // consol(result.data);
            setLoadtable(true);
            setQuerySuccess(false);

            toast.success(' deleted Successfully ', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'green',
                color: 'white',
              },
            });
          })
          .catch((err) => {
            //   this.setState({ querySuccess: false });
            setQuerySuccess(false);

            toast.success(`${err?.response?.data?.message || 'Server Error'}`, {
              position: 'bottom-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                backgroundColor: 'red',
                color: 'white',
              },
            });
          });
      } else {
        setQuerySuccess(false);

      }
    });

  }

  const returnValue = (data, type, Name) => {
    const keys = Object.keys(data); // Extract keys from the data object
    const values = Object.values(data); // Extract values from the data object
    // Create a new object with the existing data from outer component
    // and add/update the new key-value pair
    console.log(keys, values, "input filed values ")
    // if(keys[0] ==='PartNumber'){
    //     SendPartNumber(values[0])
    // }
    const newData = {
      ...datafromoutercomponent,
      [keys[0]]: values[0] // Assuming there's only one key-value pair in the data object
    };

    // Update the outer component data
    setdatafromoutercomponent(newData);

    return newData;
  }
  return (
    <React.Fragment>
      {querySuccess && <Loading />}
      {/* <div className=" text-center heading-bg mb-4">
        <h4 className="text-white p-0 m-0" >
          {MasterHeading} master
        </h4>
      </div> */}
      <div className="row">
        {renderComp && renderComp.length > 0 && renderComp.map(item => {
          { console.log(renderComp, "fsdkfgs") }

          if (item.inputComp === 'DropDownInputCompForObject') {
            return item.allInput.map(item =>
              <DropDownInputCompForObject title={item.title} Name={item.Name} data={item.data} option={item.option} returnValue={(data) => returnValue(data)} />
            );
          } else if (item.inputComp === 'TextInputComp') {
            return item.allInput.map(one =>
              TextInputComp(one.title, one.Name, one.data, returnValue, one.type));
          } else if (item.inputComp === 'TextInputFieldComp') {
            return item.allInput.map(one =>
              TextInputFieldComp(one.title, one.Name, one.data, returnValue, one.type));
          }

        })}
      </div>
      <div className="d-flex">


        <div className="modal fade " id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className={`modal-dialog  ${modalSize || ''}`}>
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title fs-5" id="staticBackdropLabel">Add {MasterHeading}</h4>
                <button type="button" className="btn btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">

                <div>
                  <div className="w-100 ">
                    <div className="d-flex justify-content-between d-flex justify-content-between form-group text-center">
                      <label className="d-flex align-items-center ">{FieldName}</label>
                      <input
                        style={{ width: '60%' }}
                        type="text"
                        className="form-control border "
                        placeholder={FieldName}
                        name={FieldName}
                        onChange={handleOnChange}
                        value={dataForApi[FieldName] || ''}
                      />
                    </div>
                    {errors[FieldName] && <div className="alert small alert-danger">{errors[FieldName]}</div>}
                  </div>

                  <div className=" ">

                    <div className="text-center">
                      <button
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          handleSubmit(dataForApi);
                        }}
                      >
                        Submit
                      </button>
                    </div>
                    {/* <div className="text-center" style={{ marginTop: 10 }}>
          <button
            className="btn btn-primary"
            onClick={() => {
              history.push('/setting/equipmenttype/list');
            }}
          >
            Cancel
          </button>
        </div> */}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
        type="button" className="btn btn-primary mx-2 rounded-4 shadow" data-bs-toggle="modal" data-bs-target="#staticBackdrop" onClick={() => { setActionStatus('Add'); setdataForApi({}) }} >
        + Add {MasterHeading}
      </button>
      <button type="button" className="btn btn-primary mx-2 rounded-4 shadow" onClick={() => handleUploadGuagesDoc()}><FontAwesomeIcon icon={faFileImport} /> Excel Import</button>
      {InputData.length > 0 && FieldName.length > 0 ? <Table id='' onSort={handleSort} columns={columns} sortColumn={sortColumn} data={InputData} /> : ''}

    </React.Fragment>
  );
};

export default MasterTemplate;
